export const GET_CHART_DATA = "GET_CHART_DATA";
export const SET_PIE_CHART_DATA = "SET_PIE_CHART_DATA";
export const SET_BAR_CHART_DATA = "SET_BAR_CHART_DATA";
export const SET_MIXED_BAR_CHART_DATA = "SET_MIXED_BAR_CHART_DATA";
export const SET_CHART_VIEW_TYPE = "SET_CHART_VIEW_TYPE";
export const SET_INTERNAL_VIEW_TYPE = "SET_INTERNAL_VIEW_TYPE";



// WEBPACK FOOTER //
// ./src/types/chartActionTypes.js